import { FC } from "react";
import {
    EsIcon,
    FrIcon,
    ItIcon,
    PtIcon,
    GbIcon,
    UaIcon,
    UsIcon,
    DeIcon,
    NlIcon,
    SeIcon,
} from "@smile2impress/components";
import {
    Box,
    Container,
    Picture,
    Heading,
    Flex,
    Icon,
} from "@smile2impress/components/relaunch";

import { ClinicsMapProps } from "./ClinicsMap.types";

export const ClinicsMap: FC<ClinicsMapProps> = ({ title, image }) => {
    const flagIcons = [
        EsIcon,
        FrIcon,
        ItIcon,
        PtIcon,
        GbIcon,
        UaIcon,
        UsIcon,
        DeIcon,
        NlIcon,
        SeIcon,
    ];

    return (
        <Box position="relative" px={[0, 0, 4]}>
            <Container position="absolute" top={0} left={0} zIndex={1}>
                <Heading
                    textStyle="title1"
                    textAlign="center"
                    mb={1}
                    color="text.base"
                >
                    {title}
                </Heading>
                <Flex justifyContent="center">
                    {flagIcons.map((flagIcon, index) => (
                        <Icon
                            key={index}
                            as={flagIcon}
                            boxSize={[2, 2, "44px"]}
                            mr="10px"
                            _last={{ mr: 0 }}
                        />
                    ))}
                </Flex>
            </Container>
            <Box pt={["70px", 3, 4]}>
                <Picture {...image} />
            </Box>
            <Box
                position="absolute"
                left={0}
                bottom={0}
                w="100%"
                h={["135px", "135px", "170px"]}
                bg="linear-gradient(0deg, #FFF 0%, rgba(255, 255, 255, 0.00) 100%)"
                zIndex={1}
            />
        </Box>
    );
};
